import { MessageBig } from 'components';

export const NotFound = () => {
  return <MessageBig message={'Page not found'} />;
};
